var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "actions" },
    [
      _c(
        "md-dialog",
        {
          attrs: { "md-active": _vm.showRemoveConfirmation },
          on: {
            "update:mdActive": function ($event) {
              _vm.showRemoveConfirmation = $event
            },
            "update:md-active": function ($event) {
              _vm.showRemoveConfirmation = $event
            },
          },
        },
        [
          _c("md-dialog-title", [_vm._v(_vm._s(_vm.t("app-are-you-sure")))]),
          _vm._v(" "),
          _c("md-dialog-content", [
            _vm._v(_vm._s(_vm.t("app-are-you-sure-you-want-to-delete")) + " "),
            _c("i", [_vm._v(_vm._s(_vm.program.title))]),
            _vm._v(". "),
            _c("b", [_vm._v(_vm._s(_vm.t("app-cannot-be-undone")))]),
          ]),
          _vm._v(" "),
          _c(
            "md-dialog-actions",
            [
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  on: {
                    click: function ($event) {
                      _vm.showRemoveConfirmation = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.t("app-cancel")))]
              ),
              _vm._v(" "),
              _c(
                "md-button",
                {
                  staticClass: "md-primary",
                  on: {
                    click: function ($event) {
                      return _vm.remove()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.t("app-delete")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.$route.params.id
        ? _c(
            "button",
            {
              staticClass: "danger",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  _vm.showRemoveConfirmation = true
                },
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.t("app-delete")) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.active !== "details" && _vm.$route.params.id
        ? _c(
            "button",
            { attrs: { type: "button" }, on: { click: _vm.onDetailsClick } },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.t("app-review-program-details")) + "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.app.bootstrap.country === "us" &&
      _vm.active !== "settings" &&
      _vm.$route.params.id &&
      _vm.program.director
        ? _c(
            "button",
            {
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.onSettingsClick()
                },
              },
            },
            [_vm._v("\n    " + _vm._s(_vm.t("app-program-settings")) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.active !== "approval" && _vm.$route.params.id && _vm.program.director
        ? _c(
            "button",
            { attrs: { type: "button" }, on: { click: _vm.onApprovalClick } },
            [
              _vm._v(
                "\n    " + _vm._s(_vm.t("app-review-program-approval")) + "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.active !== "administrators" &&
      _vm.$route.params.id &&
      _vm.program.director
        ? _c(
            "button",
            { attrs: { type: "button" }, on: { click: _vm.onAdminsClick } },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.t("app-review-program-administrators")) +
                  "\n  "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$route.params.id
        ? _c("button", { attrs: { type: "submit" } }, [
            _vm._v("\n    " + _vm._s(_vm.t("app-save")) + "\n  "),
          ])
        : _c("button", { attrs: { type: "submit" } }, [
            _vm._v("\n    " + _vm._s(_vm.t("app-submit")) + "\n  "),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }